import { Button } from "components/DesignSystem/Button/Button";
import { useModal } from "hooks/useModal";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useAmendFilingMutation } from "store/apis/task";
import { LocalFileOrInkleDocs } from "types/Models/reviewDocumentAndBalancingPayment";
import { Task } from "types/Models/task";
import { TASK_AMENDMENT_COMPLETED } from "constants/taskStates";
import { useToast } from "hooks/useToast";
import { UploadFile } from "components/UploadFile/UploadFile";

export const Form1099InprogressNextButton = ({
  isAmendment,
  moveToNextState,
  task,
}: {
  isAmendment: boolean;
  moveToNextState?: () => void;
  task: Task;
}) => {
  const { isCustomer } = useRoleBasedView();
  const uploadFileModal = useModal();
  const [amendTask, { isLoading }] = useAmendFilingMutation();
  const { alertToast } = useToast();

  const onFileSelect = async (attachments: LocalFileOrInkleDocs[]) => {
    try {
      const inkleDocs: string[] = [];
      const localFiles: Blob[] = [];
      attachments.forEach((attachment) => {
        if ("uuid" in attachment) {
          inkleDocs.push(attachment.uuid);
        } else {
          //@ts-ignore
          localFiles.push(attachment);
        }
      });
      const groupId = task?.group_uuid;
      const taskId = task?.uuid;
      const formData = new FormData();
      formData.append("file_ids", inkleDocs.join(","));
      localFiles.forEach((file) => formData.append("files", file));
      formData.append("next_state_type", TASK_AMENDMENT_COMPLETED);

      await amendTask({
        taskId,
        groupId,
        payload: formData,
      }).unwrap();
      uploadFileModal.close();
    } catch (e: any) {
      alertToast({ message: e?.data?.error?.message });
    }
  };

  return (
    <>
      <Button
        disabled={isCustomer}
        customType="primary"
        size="regular"
        onClick={isAmendment ? uploadFileModal.open : moveToNextState}
      >
        Next
      </Button>
      {uploadFileModal.isOpen && (
        <UploadFile
          title="Upload amendment document"
          showModal={uploadFileModal.isOpen}
          closeModal={uploadFileModal.close}
          onFileSelect={onFileSelect}
          prevSelectedFiles={[]}
          isLoading={isLoading}
        />
      )}
    </>
  );
};
